
import Vue from "vue";

import NoDataAvailable from "@/components/NoDataAvailable.vue";
import Spinner from "@/components/Spinner.vue";
import LockedIcon from "@/components/icons/LockedIcon.vue";

export default Vue.extend({
  name: "MachineStatusRvs",
  components: { NoDataAvailable, Spinner, LockedIcon },
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    items() {
      return this.$store.state.modelViewData?.rvs?.rvs_diagram_status || [];
    },
    isNotUpgrade(): any {
      if (this.$store.state.user.role === "admin") return false;
      const rvsUpgrade = this.$store.state.company.rvs_upgrade ? false : true;
      return rvsUpgrade;
    },
  },
  methods: {
    overAllStatus(datas: any[]) {
      return datas.length ? Math.max(...datas.map((m) => m.overAllSensorStatus)) : 0;
    },
    statusName(code: number) {
      if (code === 0) return "normal";
      if (code === 1) return "warning";
      if (code === 2) return "alarm";
      if (code === -1) return "offline";
      else return "";
    },
  },
});
